import { useLoader } from "@react-three/fiber";
import axios from "axios";
import MDButton from "components/MDButton";
import L from "leaflet";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import MiniMap from "leaflet-minimap";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, Col, Form, Row } from "reactstrap";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { basicURL } from "../../apiManager/APIConfig";
import logo from "../../assets/images/logo.png";
import CustomDrawer from "../../components/CustomDrawer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { GetSlideByIdCall } from "../../redux/api/title.api";
import { DeleteFile } from "../../redux/api/upload.api";
import { store } from "../../redux/store";
import "./map.css";

const PUBLIC_SLIDE_TYPES = ["his", "emb", "three_d_model", "presentation"];

function getPinLabel(index) {
  const labels = ["A", "B", "C", "D"];
  return labels[index] ?? String.fromCharCode(65 + index);
}

function escapeHtml(text) {
  if (text == null || typeof text !== "string") return "";
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

function createSlidePinIcon(label) {
  return L.divIcon({
    className: "slide-pin-marker-wrapper",
    html: `<div style="display:flex;flex-direction:column;align-items:center;line-height:1;pointer-events:auto;">
      <div style="width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:14px solid #28a745;"></div>
      <div style="background:#007bff;color:white;font-weight:bold;font-size:13px;border-radius:4px;padding:3px 8px;margin-top:2px;min-width:22px;text-align:center;box-sizing:border-box;">${label}</div>
    </div>`,
    iconSize: [24, 44],
    iconAnchor: [12, 0],
  });
}

function ShowTile({ history }) {
  const userData = history?.location?.state?.data?.array;
  const fileInputRef = useRef();
  const { id, lang } = useParams();
  const mapRef = useRef(null); // Ref for storing map instance
  const drawnItemsRef = useRef(null);
  const pendingNewLayerRef = useRef(null);

  const content = userData?.content;

  const [info, setInfo] = useState([]);
  const [geoJson, setGeoJson] = useState([]);

  const [showLoader, setShowLoader] = useState(false);
  const [uploadProgress, setUploadPercentage] = useState(0);

  const [drawerOpen, setOpenDrawer] = useState(false);
  const [activeDeleteButton, setActiveDeleteButton] = useState(false);
  const [tileURL, setTitleURL] = useState(``);
  const [key, setKey] = useState(0);

  const role = store.getState().auth?.role;
  const isPublicSlide = PUBLIC_SLIDE_TYPES.includes(
    geoJson?.parentTitle?.type || geoJson?.Titles?.type || geoJson?.titles?.type || ""
  );
  const canEditSlide = !isPublicSlide || role === "admin";
  ////3d modles

  useEffect(() => {
    fetchSlide();
  }, []);
  /////////
  /////////
  function generateUniqueId() {
    return "id-" + Math.random().toString(36).substr(2, 16);
  }
  const fetchSlide = async () => {
    const params = new URLSearchParams(window.location.search);
    const includePrivatePins = params.get("private") === "1";
    const res = await GetSlideByIdCall({
      id,
      lang,
      includePrivatePins,
    });
    ////here ......
    if (mapRef.current) {
      mapRef.current.remove();
      mapRef.current = null;
    }
    setGeoJson(res);

    setActiveDeleteButton(res?.Files?.[0]?.url ? true : false);
    setTitleURL(`${res?.Files?.[0]?.url}/{z}/{x}/{y}.png`);
    // window.location.reload();
  };
  useEffect(() => {
    setTimeout(() => {

      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }

      if (!isEmpty(geoJson) && tileURL && !mapRef.current) {
        const map = L.map("map", {
          center: [-10.505, -0.09],
          zoom: 2,
          maxBounds: [
            [-90, -180],
            [90, 180],
          ],
          maxBoundsViscosity: 1,
        });
        L.tileLayer(tileURL, {
          attribution: '&copy; <a href="https://microlab.ink">Microlab</a> contributors',
          noWrap: true,
          bounds: [
            [-90, -180],
            [90, 180],
          ],
        }).addTo(map);
        //////////
        const minimapLayer = L.tileLayer(tileURL, {
          maxZoom: 0,
          noWrap: true,

          detectRetina: true,
          minZoom: 0,
          bounds: [
            [-90, -180],
            [90, 180],
          ],
          maxNativeZoom: 0,
        });
        ////////
        ////////
        new MiniMap(minimapLayer, {
          zoomLevelFixed: 2,
          position: "bottomleft",
          width: 120,
          height: 120,
          collapsedWidth: 5,
          collapsedHeight: 5,
          aimingRectOptions: {
            color: "#00f",
            weight: 1,
            fillOpacity: 0.1,
          },
        }).addTo(map);

        /////////
        ///////// show the saved pins

        const isStudent = role === "student";
        const params = new URLSearchParams(window.location.search);
        const isPrivateView = params.get("private") === "1";
        // Pins can be edited only when:
        // - user is not a student AND
        // - either this is not a public-core slide, or we're in private overlay view, or the user is admin.
        const canEditPins =
          !isStudent && (isPrivateView || !isPublicSlide || role === "admin");

        geoJson?.pins.forEach((pin, index) => {
          const location = JSON.parse(pin.locations);
          const coordinates = location.data.geometry.coordinates;
          const label = getPinLabel(index);
          const marker = L.marker([coordinates[1], coordinates[0]], { icon: createSlidePinIcon(label) }).addTo(map);

          const titleLocalization = pin.pinLocalizations?.find(
            (loc) => loc.field === "title" && loc.language === lang
          );
          const bodyLocalization = pin.pinLocalizations?.find(
            (loc) => loc.field === "body" && loc.language === lang
          );
          const pinTitle = titleLocalization?.value || "Pin";
          const pinBody = bodyLocalization?.value || "";

          if (!canEditPins) {
            // Read-only: show pin details in a popup with close button
            const popupContent = `<div class="pin-popup-content" style="min-width:180px;max-width:280px;">
              <div style="font-weight:bold;margin-bottom:6px;font-size:14px;">${escapeHtml(pinTitle)}</div>
              ${pinBody ? `<div style="font-size:13px;color:#444;line-height:1.4;">${escapeHtml(pinBody)}</div>` : ""}
            </div>`;
            marker.bindPopup(popupContent, { closeButton: true });
          } else {
            marker.on("click", () => {
              const updatedPin = {
                ...pin,
                title: pinTitle,
                body: pinBody,
              };
              setInfo(updatedPin);
              setTimeout(() => toggleDrawer(true), 200);
            });
          }
        });
        /////////
        /////////
        // FeatureGroup and draw toolbar: only when pins are editable (students & read-only views see no toolbar)
        var drawnItems;
        if (canEditPins) {
          const existingCount = Array.isArray(geoJson?.pins) ? geoJson.pins.length : 0;
          const baseLabel = getPinLabel(existingCount);
          drawnItems = new L.FeatureGroup();
          map.addLayer(drawnItems);
          drawnItemsRef.current = drawnItems;
          var drawControl = new L.Control.Draw({
            position: "topright",
            draw: {
              // Use a custom icon even while placing the marker to avoid the broken default icon
              marker: {
                icon: createSlidePinIcon(baseLabel),
              },
              polygon: false,
              polyline: false,
              rectangle: false,
              circle: false,
              circlemarker: false,
            },
            edit: {
              featureGroup: drawnItems,
              edit: false,
              remove: true, // keep only the bin (delete) action
            },
          });
          map.addControl(drawControl);
        }
        if (!isEmpty(geoJson?.pins)) {
          let geoJsonPinIndex = 0;
          L.geoJSON(geoJson?.pins, {
            pointToLayer: (feature, latlng) => {
              const label = getPinLabel(geoJsonPinIndex++);
              return L.marker(latlng, { icon: createSlidePinIcon(label) });
            },
          })
            .addTo(map)
            .on(
              "click",
              function (e) {
                if (!canEditPins) return;
                const { layer } = e;

                const id = layer?.feature.properties.id;
                setInfo({ content: content[id], markerID: id });

                setTimeout(() => {
                  toggleDrawer(true);
                }, 200);
              }.bind()
            );
        }
        ///////////////
        ///////////////
        ///////////////
        const watermark = L.control({ position: "bottomright" });
        watermark.onAdd = function (map) {
          const div = L.DomUtil.create("div", "watermark");
          div.style.background = "transparent"; // Ensure background is transparent
          div.innerHTML = `<img src=${logo} alt="Microlab Watermark" style="width: 100px; height: auto;">`;
          return div;
        };
        watermark.addTo(map);
        ///////////////
        ///////////////
        ///////////////
        ////Edit and add functions (only when pins are editable)
        if (canEditPins && drawnItems) {
          map.on("draw:created", function (e) {
            var type = e.layerType,
              layer = e.layer;

            console.log("layer draw:created : ", layer);
            if (type === "marker") {
              // showModal(layer);
              // Do marker specific actions
              const latlng = layer.getLatLng(); // Get latitude and longitude of the marker

              // Use the same visual pin style as existing pins
              const existingCount = Array.isArray(geoJson?.pins) ? geoJson.pins.length : 0;
              const newIndex = existingCount + drawnItems.getLayers().length;
              const label = getPinLabel(newIndex);
              layer.setIcon(createSlidePinIcon(label));

              // Construct GeoJSON structure
              const newFeature = {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [latlng.lng, latlng.lat], // Leaflet uses lat/lng; GeoJSON uses lng/lat
                },
                properties: {
                  id: generateUniqueId(), // Replace with your logic to generate an ID
                },
              };

              setInfo(newFeature);
              pendingNewLayerRef.current = layer;
              // Open dialog immediately for new pin
              setTimeout(() => {
                toggleDrawer(true);
              }, 0);
            }
            layer.on("click", (e) => {
              toggleDrawer(true);
            });
            ///////////////
            ///////////////
            ///////////////
            // Do whatever else you need to. (save to db; add to map etc)
            drawnItems.addLayer(layer);
          });

          map.addLayer(drawnItems);
        }
        ///////////////
        ///////////////
        ///////////////


        return () => {
          // Cleanup map on component unmount
          if (mapRef.current) {
            mapRef.current.remove();
            mapRef.current = null;
          }
          drawnItemsRef.current = null;
          pendingNewLayerRef.current = null;
        };
      }
    }, 1000);

  }, [tileURL]);

  const handleAddMaterial = async (event) => {
    if (activeDeleteButton) {
      const file_id = geoJson?.Files?.[0]?.id;
      const confirmation = window.confirm(
        "Are you sure you want to delete this slide? You pins will still remain on the screen."
      );
      if (confirmation) {
        DeleteFile(file_id);
        window.location.reload();
      }
    } else {
      const file = event.target.files[0];
      if (file) {
        try {
          setShowLoader(true);
          // Handle `.zip` file upload
          const formdata = new FormData();
          formdata.append("file", file);
          formdata.append("entity_type", "slide");
          formdata.append("entity_id", id);
          formdata.append("destination", "slides");
          formdata.append("folder_name", "slides");

          const access_token = store.getState().auth?.access_token;
          let myHeaders = new Headers();
          myHeaders.append("Authorization", access_token);

          myHeaders = {
            Authorization: access_token,
          };

          const response = await axios.post(`${basicURL}/file/upload`, formdata, {
            headers: myHeaders,
            onUploadProgress: (progressEvent) => {
              // Calculate the progress percentage
              const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
              setUploadPercentage(percent);
            },
          });
          setShowLoader(false);
          console.log("pippo response", response);
          setTitleURL(`${basicURL}/${response?.data?.extracted_files?.[1]?.path}/{z}/{x}/{y}.png`);

          console.log(
            "ZIP file uploaded:",
            `${basicURL}/${response?.data?.extracted_files?.[1]?.path}/{z}/{x}/{y}.png`
          );
          window.location.reload();
        } catch (error) {
          console.error("Upload error:", error);
        }
      }
    }
  };

  const toggleDrawer = (open, cancelNew = false) => {
    if (!open && cancelNew && pendingNewLayerRef.current && drawnItemsRef.current) {
      try {
        drawnItemsRef.current.removeLayer(pendingNewLayerRef.current);
      } catch (e) {
        // ignore if already removed
      }
      pendingNewLayerRef.current = null;
    }
    setOpenDrawer(open);
  };
  const uploaderTitle =
    uploadProgress != 100
      ? "uploadProgress: "
      : "Extracting the zip file and this may take a while ...";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="content">
        <CardHeader>
          <CardTitle tag="h5">
            {canEditSlide && !activeDeleteButton ? (
              <div>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleAddMaterial}
                />
                <MDButton
                  style={{ marginBottom: 15 }}
                  color={"info"}
                  variant="contained"
                  onClick={() => fileInputRef.current.click()} // Trigger the hidden file input
                >
                  Upload Slide
                </MDButton>
              </div>
            ) : canEditSlide && activeDeleteButton ? (
              <MDButton
                style={{ marginBottom: 15 }}
                color={"primary"}
                variant="contained"
                onClick={() => handleAddMaterial()}
              >
                Delete Slide
              </MDButton>
            ) : isPublicSlide ? (
              <span style={{ marginBottom: 15, color: "#666", fontSize: 14 }}>
                View only — only admin can upload or delete public slides.
              </span>
            ) : null}
          </CardTitle>
          {showLoader && (
            <CardBody>
              <Form>
                <div>
                  <div>
                    {uploaderTitle} {Math.round(uploadProgress)}%
                  </div>
                  <div
                    style={{ marginBottom: 20, height: "10px", backgroundColor: "#ddd" }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: `${uploadProgress}%`,
                        backgroundColor: "green",
                      }}
                    ></div>
                  </div>
                </div>
              </Form>
            </CardBody>
          )}
        </CardHeader>

        <Row>
          <Col md="12">
            <Card className="card-user">

              <CardBody>
                <Form>
                  <div id={"map"} style={{ width: "100%", height: "70vh" }} />
                  <CustomDrawer
                    data={info}
                    lang={lang}
                    slide_id={id}
                    fetchSlide={fetchSlide}
                    open={drawerOpen}
                    toggleDrawer={toggleDrawer}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>
    </DashboardLayout>
  );
}

const Model = ({ fbxUrl, onLoad }) => {
  const fbx = useLoader(FBXLoader, fbxUrl, (loader) => {
    loader.manager.onLoad = onLoad;
  });

  return <primitive object={fbx} />;
};

export default ShowTile;
